import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IReelDetails} from "../types/IReelDetails";

export const getReelDetails = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getReelDetails: build.query<IReelDetails | null, {id: number}>({
            query: (params) => ({
                url: apiV2ListLink.reels.details(Scenario.REEL_DETAIL, {reelId: params.id}),
                params
            })
        })
    })
});

export const {useGetReelDetailsQuery} = getReelDetails;
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IReelDetails} from "../types/IReelDetails";

export const getReelDetails = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getReelDetails: build.query<IReelDetails | null, {id: number}>({
            query: (params) => ({
                url: apiV2ListLink.reels.details(Scenario.REEL_DETAIL, {reelId: params.id}),
                params
            })
        })
    })
});

export const {useGetReelDetailsQuery} = getReelDetails;
